import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { TwoLineLabelTooltip } from "../TwoLineLabelTooltip";

const CLASSNAMES = {
  h: style.tooltip_horizontal,
  v: style.tooltip_vertical,
};
// Helper function to detect if label is a two-line label
const isTwoLineLabel = (label) => {
  return (
    typeof label === "object" &&
    label !== null &&
    label.topLine &&
    label.bottomLine &&
    typeof label.topLine === "object" &&
    typeof label.bottomLine === "object"
  );
};

export function LabelTooltip({ labelStyle, label, orientation }) {
  // If it's a two-line label, use the TwoLineLabelTooltip component
  if (isTwoLineLabel(label)) {
    return (
      <TwoLineLabelTooltip
        labelStyle={labelStyle}
        label={label}
        orientation={orientation}
      />
    );
  }

  // Otherwise, use the original single-line label logic
  const className = CLASSNAMES[orientation];

  return (
    <div className={`${className} tooltip_horizontal`} style={labelStyle}>
      <p>
        <ReactMarkdown
          rehypePlugins={[rehypeRaw]}
          components={{ p: React.Fragment }}
        >
          {label.replace("\\_", "_")}
        </ReactMarkdown>{" "}
      </p>
    </div>
  );
}

LabelTooltip.propTypes = {
  /**
   * Style for the label
   */
  labelStyle: PropTypes.object,
  /**
   * Label to display on tooltip - can be string or two-line label object
   */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      topLine: PropTypes.shape({
        text: PropTypes.string.isRequired,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
      }),
      bottomLine: PropTypes.shape({
        text: PropTypes.string.isRequired,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
      }),
    }),
  ]),
  /**
   * To display the tooltip in horizontal[h]/veritcal[v] orientation
   */
  orientation: PropTypes.oneOf(["h", "v"]),
};

LabelTooltip.defaultProps = {
  labelStyle: {},
  orientation: "h",
};
